const ArrowLittleRightIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" {...props}>
    <path fill="#C6CDD0" fillRule="evenodd" d="M2 11.4L.6 10l4-4-4-4L2 .6 7.4 6z" />
  </svg>
)

export default ArrowLittleRightIcon
